/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/naming-convention */
import { Box, Button, type ChakraProps, Flex, Img, useToast } from "@chakra-ui/react"
import { useAtom } from "jotai"
import { formBoxStyleProps, FormElement } from "../../../components/commons/globalFormComponent"
import { SubTitle } from "../../../components/commons/sub-title"
import { userDetailsAtom, userProfileDataAtom } from "../../../components/Menu/menu.store"
import { failForm, UPDATE_USERPROFILE } from "../signupNew/signup.support"
import userProfileFormJSON from "./userProfile.json"
import snapLogo from "../../../assets/images/Snap_fire_systems_logowhite.png"
import userProfile from "../../../assets/images/userProfile.svg"
import { gql, useLazyQuery, useMutation } from "@apollo/client"
import React, { useEffect, useRef, useState } from "react"
import { type UserProfileDataInterface, type UserProfileFormDataInterface } from "../../../components/commons/commonTypes"
import { ValidateForm } from "./userProfile.support"
import { logout } from "../../../components/Menu/menu.support"
import { useNavigate } from "react-router"
import WhiteFireLeft from "../../../assets/images/white_fire_left.png"
import WhiteFireRight from "../../../assets/images/white_fire_right.png"
import { Paths } from "../../../common/commonConstants"
// import { Paths } from '../../../common/commonConstants'

export const GETUSER_PROFILE = gql(`
query ViewProfile($userId: Int!) {
  viewProfile(user_id: $userId) {
    user_id
    first_name
    last_name
    email_address
    company_name
    address1
    address2
    suburb
    city
    state
    pincode
    company_logo
    supplier
  }
}`)
export const DELETE_ACCOUNT = gql(`mutation DeleteProfile($userId: Int!) {
  deleteProfile(user_id: $userId)
}`)

export const UserProfile = ({ onBackCallback }: { onBackCallback: () => void }): JSX.Element => {
  const userProfileForm = useRef<HTMLFormElement>(null)
  const toast = useToast()
  const navigate = useNavigate()
  const [getUserProfileDataAtom, setUserProfileDataAtom] = useAtom(userProfileDataAtom)
  const [savedUserDetails, setSavedUserDetails] = useAtom(userDetailsAtom)
  const { mandatory, optional } = userProfileFormJSON as {
    mandatory: UserProfileFormDataInterface[]
    optional: UserProfileFormDataInterface[]
  }
  const [getModifiedUserDetails, setModifiedUserDetails] = useState<UserProfileDataInterface>({})
  const [userID, setUserID] = useState("")

  const handleFormElementChange = (value: string, name: string): void => {
    setModifiedUserDetails(prev => ({
      ...prev,
      [name]: value
    }))
    setUserProfileDataAtom(prev => ({
      ...prev,
      [name]: value
    }))
  }
  const [fetchUserProfileData, { data: userProfileData, loading, error }] = useLazyQuery(GETUSER_PROFILE, {
    fetchPolicy: "network-only"
  })
  const [updateUserProfileData, { data: userProfileReturnData, loading: userProfileUpdating, error: userProfileUpdateError }] =
    useMutation(UPDATE_USERPROFILE)
  const [deleteAccount, { data: deleteAccountData, loading: deleteAccountloading }] = useMutation(DELETE_ACCOUNT)

  // extract non empty values from object
  const filterEmptyValues = (obj: Record<string, string>): Record<string, string> =>
    Object.keys(obj).reduce<Record<string, string>>((acc, key): Record<string, string> => {
      if (obj[key].length && obj[key] !== "") {
        acc[key] = obj[key]
      }
      return acc
    }, {})

  // Form submit handler
  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    const filteredEmptyValues = filterEmptyValues(getModifiedUserDetails as Record<string, string>)
    const validationResult = ValidateForm(userProfileForm?.current, filteredEmptyValues, toast)
    if (validationResult?.isValid && savedUserDetails) {
      updateUserProfileData({
        variables: {
          ...filteredEmptyValues,
          user_id: savedUserDetails._id
        }
      }).catch(err => {
        console.error(err)
      })
    }

    event.preventDefault()
  }

  useEffect(() => {
    if (error?.message || userProfileUpdateError?.graphQLErrors) {
      failForm(error?.message || (userProfileUpdateError?.graphQLErrors[0] as unknown as string) || "Error", toast)
    }
  }, [error, userProfileUpdateError])

  useEffect(() => {
    if (userProfileData?.viewProfile) {
      setModifiedUserDetails({})
      setUserProfileDataAtom({
        ...userProfileData?.viewProfile,
        new_email_address: userProfileData?.viewProfile?.email_address
      })
    }
  }, [userProfileData])

  const handleAccountDeletion = (): void => {
    // confirm if the user wants the delete the account
    const confirmation = window.confirm("Are you sure you want to delete your account?. This is permanent and cannot be undone.")
    if (confirmation && savedUserDetails) {
      // handle account deletion here
      // navigate(Paths.LOGIN.logout)
      deleteAccount({
        variables: {
          userId: savedUserDetails._id
        }
      }).catch(err => {
        console.error(err)
      })
    }
  }
  useEffect(() => {
    const { new_password, password, new_email_address } = getModifiedUserDetails

    if (userProfileReturnData?.updateProfile === "success") {
      if (new_password?.length && password) {
        alert("Password changed successfully. You will now be logged out. Please login with your new credentials")
        setSavedUserDetails({})
        logout(navigate)
      }
      if (new_email_address && new_email_address !== savedUserDetails?.email_address) {
        alert("you will now be logged out. Please login with your new credentials after confirming your email address")
        setSavedUserDetails({})
        logout(navigate)
      }
      toast({
        title: "Update Success",
        status: "success",
        isClosable: true,
        duration: 2000
      })
    }
    if (userProfileReturnData?.errors) {
      toast({
        title: "Update Failed",
        status: userProfileReturnData?.errors[0],
        isClosable: true,
        duration: 2000
      })
    }
  }, [userProfileReturnData])

  interface GetDefaultCustomSelectValueInterface {
    label: string
    value: string
  }
  const getDefaultCustomSelectValue = (
    customSelectOptions: GetDefaultCustomSelectValueInterface[] | undefined,
    value: string,
    name: string,
    getUserProfileDataAtom: UserProfileDataInterface
  ): GetDefaultCustomSelectValueInterface => {
    const result = customSelectOptions?.find(option => option.value === (getUserProfileDataAtom[name] as string))
    if (!result) {
      return { value, label: value }
    }
    return result
  }

  useEffect(() => {
    if (deleteAccountData?.deleteProfile === "success") {
      toast({
        title: "Account deleted",
        status: "success",
        isClosable: true,
        duration: 2000
      })
      setTimeout(() => {
        navigate(Paths.LOGIN.logout)
      }, 3000)
    }
  }, [deleteAccountData])

  interface ParsedSavedDetailsInterface {
    _id: string
    email_address: string
  }
  useEffect(() => {
    const savedDetails = localStorage.getItem("user-details") ?? sessionStorage.getItem("user-details")
    const { _id, email_address } = JSON.parse(savedDetails ?? "{}") as ParsedSavedDetailsInterface
    setTimeout(() => {
      if (_id && email_address) {
        fetchUserProfileData({
          variables: {
            userId: _id
          }
        }).catch(() => {
          // Error handled by Apollo Client
        })
      }
    }, 500)

    setUserID(_id)
  }, [])

  const getStateWidth = (name: string, formControlProps: any): ChakraProps => {
    if (name === "state" && getModifiedUserDetails[name] && getModifiedUserDetails[name] !== "") {
      return { width: "calc(77% - 30px)", paddingRight: "30px" } satisfies ChakraProps
    }

    return formControlProps as ChakraProps
  }

  return (
    <Box
      backgroundImage={["", "", `url(${WhiteFireLeft}), url(${WhiteFireRight})`, `url(${WhiteFireLeft}), url(${WhiteFireRight})`]}
      bgRepeat="no-repeat,no-repeat"
      backgroundPosition="0 0, 100% 100%"
      bgColor="primary"
    >
      <Flex align="center" justify={"center"} flexDir="column" mb="63px">
        <Img src={snapLogo} w="239px" mt="59px" />
        <SubTitle
          textProps={{
            color: "white",
            w: "250px",
            textAlign: "center",
            pt: "4px",
            bg: `url(${userProfile}) no-repeat 205px 0px`,
            bgSize: "36.4px !important"
          }}
          boxProps={{ mt: "11px", w: "auto", mb: "32px" }}
          value={"User Settings"}
        />
        <Flex {...formBoxStyleProps} align="center" maxWidth="255px">
          <form style={{ width: "100%" }} ref={userProfileForm} name="registrationForm" method="post" onSubmit={handleFormSubmit}>
            {userID && (
              <>
                {mandatory?.map(
                  ({ name, type, placeHolder, label, htmlValidation, optionalLabel, formLabelTextProps }: UserProfileFormDataInterface) => (
                    <FormElement
                      key={name}
                      name={name}
                      type={type}
                      placeHolder={placeHolder}
                      label={label}
                      requiredText="*"
                      value={getUserProfileDataAtom[name]}
                      optionalLabel={optionalLabel}
                      onChangeCallBack={(value: string) => {
                        handleFormElementChange(value, name)
                      }}
                      htmlValidation={htmlValidation}
                      showEditIcon={label !== "Password" && getUserProfileDataAtom[name] !== ""}
                      formLabelTextProps={formLabelTextProps}
                    />
                  )
                )}

                <Flex mt="32px" flexWrap={"wrap"}>
                  {optional?.map(
                    ({
                      name,
                      type,
                      placeHolder,
                      label,
                      htmlValidation,
                      inputStyles,
                      formControlProps,
                      formLabelOptionalTextProps,
                      customSelectOptions,
                      formLabelTextProps
                    }: UserProfileFormDataInterface) => (
                      <FormElement
                        key={name}
                        name={name}
                        type={type}
                        placeHolder={placeHolder}
                        label={label}
                        value={getUserProfileDataAtom[name]}
                        onChangeCallBack={(value: string) => {
                          handleFormElementChange(value, name)
                        }}
                        htmlValidation={htmlValidation}
                        inputStyles={inputStyles}
                        formControlProps={getStateWidth(name, formControlProps)}
                        formLabelOptionalTextProps={formLabelOptionalTextProps}
                        customSelectOptions={customSelectOptions}
                        defaultCustomSelectValue={getDefaultCustomSelectValue(
                          customSelectOptions,
                          getModifiedUserDetails[name] || getUserProfileDataAtom[name] || "",
                          name,
                          getUserProfileDataAtom
                        )}
                        showEditIcon={!!(getUserProfileDataAtom[name] && getUserProfileDataAtom[name] !== "")}
                        formLabelTextProps={formLabelTextProps}
                      />
                    )
                  )}
                </Flex>
                <Flex w="255px" justify={"flex-start"} mt="34px" alignContent={"center"}>
                  <Button
                    bg="transparent"
                    pl="10"
                    ml="-36px"
                    color="white"
                    textDecoration={"underline"}
                    fontWeight="700"
                    fontSize="15px"
                    _hover={{ bg: "transparent" }}
                    onClick={onBackCallback}
                  >
                    Back
                  </Button>
                  <Button _hover={{ bg: "white" }} variant="Button1RegularOutline" type="submit" isLoading={loading || userProfileUpdating}>
                    Confirm
                  </Button>
                </Flex>
              </>
            )}
            <Flex justify={"center"}>
              <Button
                minW="120px !important"
                variant="Button1RegularOutline"
                bg={"transparent"}
                border="1px solid white"
                onClick={handleAccountDeletion}
                color="white"
                mt="34px"
                width="203px"
                height="30px"
                isLoading={deleteAccountloading}
              >
                Delete Account
              </Button>
            </Flex>
          </form>
        </Flex>
      </Flex>
    </Box>
  )
}
